const SectionContent = {
  topSection: {
    en: {
      poster: `${process.env.ASSETS_PREFIX}/products/products_rutech_robots.png`,
      title: 'RuTech Robotics',
      descriptionHtml: `As the Exclusive distributor and technical service partner of Pudu Technology in North America, RuTech promotes commercial service robots in the following industries restaurants, hotel & event spaces, corporate offices, warehouses & distribution centers, medical care facilities, airports, shopping centers etc...`,
      description: ``,
      topLink: {
        text: 'Visit RuTech Website',
        href: 'https://www.rutechusa.com/',
      },
    },
    zh: {
      poster: `${process.env.ASSETS_PREFIX}/products/products_rutech_robots.png`,
      title: 'Chowbus POS系统: RuTech餐厅机器人，节约人工',
      descriptionHtml: `作为普度科技北美最大的分销商和技术合作伙伴，Rutech为餐饮，医疗，酒店服务，购物，机场，办公作业以及库物流中心行业提供专业的机器人营销策划以及技术和服务支持`,
      description: ``,
      topLink: {
        text: '点击查看RuTech网站',
        href: 'https://www.rutechusa.com/',
      },
    },
  },
  advances: {
    en: {
      title: `Efficiency at Its Finest`,
      subTitle: `Delivery robots bring different advantages to different industries. The automation of these tasks by robots is also helping small businesses with the labor shortages we all know are affecting every aspect of our country in our economy. Without enough employees, businesses are not able to serve customers at maximum volume and operate at peak performance.`,
      featureList: [
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_rutech_robots_feature_1.png`,
          imageAlt: 'service & support',
          title: '',
          description: 'We pride ourselves in the service & support we provide our clients.',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_rutech_robots_feature_2.png`,
          imageAlt: 'on-site ',
          title: '',
          description: 'Whether its on-site, via video, phone or email, we make sure to be 100% hands on.',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_rutech_robots_feature_3.png`,
          imageAlt: 'immense library',
          title: '',
          description: 'We also have an immense library of web tools and tutorials for our clients.',
        },
      ],
    },
    zh: {
      title: `效率以及服务至上`,
      subTitle: `餐厅机器人在节省人工方面发挥了巨大的作用`,
      featureList: [
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_rutech_robots_feature_1.png`,
          imageAlt: '专业和全面',
          title: '',
          description: '我们拥有最专业和全面的人工服务和科技支持',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_rutech_robots_feature_2.png`,
          imageAlt: '现场教学',
          title: '',
          description: '无论是现场教学，或者线上视频指导，我们保证100%的亲力亲为',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_rutech_robots_feature_3.png`,
          imageAlt: '充足的线上资料库',
          title: '',
          description: '我们也有充足的线上资料库帮助我们顾客实现机器人的熟练操作',
        },
      ],
    },
  },
  features: {
    en: {
      title: `Service Bots Bring Life to Your Restaurant.`,
      items: [
        {
          layout: 'row',
          direction: 'normal',
          title: '',
          cover: `${process.env.ASSETS_PREFIX}/products/products_rutech_robots_advance_1.png`,
          description: `A service robot stands out from the crowd and gives diners something unique and exciting to focus on, which is crucial for marketing any restaurant business. Diners take pictures with the delivery robot in addition to the meals served and those pictures might be used to spread the news and promote your restaurant without cost.

          Giving your guests something to share on social media is an exceptionally effective marketing strategy that you can use without investing any money in a planned advertising effort. The more people submit and interact with your content, the more positively people will see your brand.`,
        },
      ],
    },
    zh: {
      title: '专业的餐厅机器人帮助我们建立双赢且持续的客户关系',
      items: [
        {
          layout: 'row',
          direction: 'normal',
          title: '',
          cover: `${process.env.ASSETS_PREFIX}/products/products_rutech_robots_advance_1.png`,
          description: `为食客提供新颖的服务方式，餐饮机器人因此脱颖而出，也使其成为最
          独特的营销方式。顾客在用餐时为餐饮机器人拍照留念并上传社交媒体
          的同时也为餐厅提供了免费的社交媒体宣传.
          
          社交媒体在如今已经成为了最高效的营销策略。在无需任何额外的广告
          营销投资的基础上获得大量的曝光，不仅节省了媒体投放预算，也可以
          通过内容互动树立更加积极的品牌形象.`,
        },
      ],
    },
  },

  features01: {
    en: {
      title: 'Take Your Pick',
    },
    zh: {
      title: '选择最适合你的餐厅机器人',
    },
  },
  customerVoiceInfos: [
    {
      img: `${process.env.ASSETS_PREFIX}/home/customervoice/customer-voice-products_rutech_robots.jpeg`,
      productLine: 'RoTech Robot',
      desc: {
        zh: `仅仅使用Pudu餐饮机器人6个月，我的客户群体增加15%。不仅在日常的餐厅营业中，Pudu餐饮机器人在活动举办中的表现也非常完美！他可以提供基础的餐饮供应服务，而我的员工也可以更好的专心于服务质量。我已经开始准备在我的其他餐厅和场地放置更多的服务机器人。`,
        en: `I've started using PuduBot in my restaurant for only 6 months and I have increased my customer base by 15%. PuduBot is also perfect when I host special events, and everyone loves her. My staff can now focus more on attending customers while PuduBot does all the leg work. I am ready to put more robots in my other locations.`,
      },
      restaurantName: { zh: `Sarah Fisher`, en: `Sarah Fisher` },
      location: { zh: '芝加哥/伊利诺伊州', en: 'Chicago, IL' },
      // link: '/business-types/korean-bbq/jongro-bbq',
    },
  ],
};

export default SectionContent;
